// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gLwC","label":"styles_label__25oH3"};